import { environment } from "../environments/environment";
import { isAndroid, isIOS } from "./extract-config.helper";

/**
 * Inicia Datadog con los valores de configuración para el proyecto
 */
export const initDatadog = () => {
    try {

        initLogs();
        initSessionReplay();

    } catch (error) {

        console.error(error);
    }
}

/**
 * Loggeo de usuario en Datadog
 * @param email email de usuario loggeado
 */
export const loggerDatadog = (email) => {
    try {

        window.DD_LOGS.logger.addContext('user.email', email);

    } catch (error) {
        console.error(error);
    }
}

/**
 * Conexión con google analytics
 */
export const connectDatadogGA = () => {
    try {

        window.DD_LOGS.logger.addContext('user.firebaseId', environment.firebaseConfig.measurementId); // tenemos apikey de firebase, no usamos google analytics

    } catch (error) {

        console.error(error);
    }
}

/**
 * Inicializa la traza de logs para DataDog
 */
export const initLogs = () => {

    try {

        window.DD_LOGS.onReady(function() {

            window.DD_LOGS.init({

                clientToken: environment.datadogConfig.logs.clientToken,
                site: 'datadoghq.com',
                forwardErrorsToLogs: true,
                sampleRate: Number(environment.datadogConfig.logs.sampleRate),
                service: 'scan-club',
                env: environment.production ? 'prod' : 'qa',
                version: isAndroid() ? environment.versions.android : isIOS() ? environment.versions.ios : environment.versions.web

            });

            connectDatadogGA();
        });

    } catch (error) {

        console.error(error);
    }
}

/**
 * Inicia Session Replay que habilita ver la navegación del usuario y cómo interactúa este con el browser
 */
export const initSessionReplay = () => {
    try {

        window.DD_RUM.onReady(function() {

            window.DD_RUM.init({
                clientToken: environment.datadogConfig.rum.clientToken,
                applicationId: environment.datadogConfig.rum.applicationId,
                site: "datadoghq.com",
                service: "scan-club",
                env: environment.production ? 'prod' : 'qa',
                version: isAndroid() ? environment.versions.android : isIOS() ? environment.versions.ios : environment.versions.web,
                sampleRate: Number(environment.datadogConfig.rum.sampleRate),
                trackInteractions: true,
                premiumSampleRate: Number(environment.datadogConfig.rum.premiumSampleRate)
            });

            window.DD_RUM.startSessionReplayRecording();

        });

    } catch (error) {

        console.error(error);
    }
}